import styled from '@emotion/styled';
import { GrayIcon } from './bulma_derived_components';

export const DisabledTrashIcon = styled(GrayIcon)`
  pointer-events: auto;
  color: #E0E0E0;
`
